import { useDispatch, useSelector } from "react-redux";
import { setModalsData, TModalsState } from "../../../../api/store/commonSlice";
import { useTranslation } from "react-i18next";
import FTModal from "../../../../components/common/FTModal";
import { MaintenanceFaultCodeResponse } from "../../../../api/types/Maintenance";

type MaintenanceFaultCodeProps = {
  faultCodeData: MaintenanceFaultCodeResponse | undefined;
  setFaultCodeData:
    | React.Dispatch<
        React.SetStateAction<MaintenanceFaultCodeResponse | undefined>
      >
    | undefined;
};
const ModalMaintenanceFaultCodes = ({
  faultCodeData,
  setFaultCodeData,
}: MaintenanceFaultCodeProps) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "admins.maintenance.detailsPage.form",
  });
  const modalsState = useSelector(
    (state: { commonReducer: { modals: TModalsState } }) =>
      state.commonReducer.modals
  );
  const dispatch = useDispatch();

  const hideModal = () => {
    dispatch(
      setModalsData({ ...modalsState, showModalMaintenanceFaultCodes: false })
    );
    if (setFaultCodeData) {
      setFaultCodeData(undefined);
    }
  };

  return (
    <FTModal
      visible={modalsState.showModalMaintenanceFaultCodes}
      heading={t("heading")}
      onHide={hideModal}
      dismissible={true}
      containerStyle="max-w-[calc(100vw-4rem)] w-[700px]"
      position="center"
    >
      <div className="min-w-[30em] flex flex-col gap-6">
        <div className="overflow-auto max-h-[40em] border border-gray-300">
          <table className="w-full">
            <thead>
              <tr className="bg-accent-blue-pale text-left">
                <th className="p-3 border border-gray-300">Fault Code</th>
                <th className="p-3 border border-gray-300">Description</th>
                <th className="p-3 border border-gray-300">Fault Location</th>
                <th className="p-3 border border-gray-300">Type</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(faultCodeData ?? {}).map(
                ([id, details], index) => (
                  <tr key={id} className="border-b border-gray-300">
                    <td className="p-3 font-bold border">{id}</td>
                    <td className="p-3 border">{details.description}</td>
                    <td className="p-3 border">{details.faultlocation}</td>
                    <td className="p-3 border">{details.type}</td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      </div>
    </FTModal>
  );
};
export default ModalMaintenanceFaultCodes;
